import axios from "axios";
import { NotComparisonService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { ComparisonResponseDTO, filtersDTO, saveStatusParticelleStruttureDTO } from "./dto";

export class NotComparisonImpl implements NotComparisonService {

    public GetNotComparison(filters: filtersDTO): Promise<ComparisonResponseDTO> {
        return axios.get("/api/notifications-comparison", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                currentNotificationId: filters.currentNotificationId,
                previousNotificationId: filters.previousNotificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public UpdateStatusParticelle(data: saveStatusParticelleStruttureDTO, id: string): Promise<void> {
        return axios.put("/api/notification-status/update-variation-causes/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateStatusStrutture(data: saveStatusParticelleStruttureDTO, id: string): Promise<void> {
        return axios.put("/api/notification-status/update-variation-causes/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}